import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { loginInfo } from '../global';

var CheckAccessibility = pathname => {
  var path = pathname.startsWith("/Kiosk/Home") ? "/Kiosk/Home" : pathname.startsWith("/Kiosk/ProductLineHome") ? "/Kiosk/ProductLineHome" : pathname;
  let accessible = (loginInfo.AccessibleUrlList && loginInfo.AccessibleUrlList.hasOwnProperty(path));

  //location control
  // if (path != "/Kiosk/Home" && loginInfo.LocationCode && loginInfo.LocationCode != '') {
  //   var locationObj = loginInfo.UserLocationList.find(x => x.LocationCode == loginInfo.LocationCode);
  //   if (locationObj != null) {
  //     if (!locationObj.AccessibleFunctionList.find(x => x.FunctionUrl == path))
  //       accessible = false;
  //   }
  // }

  if (accessible && path == "/Kiosk/Home" && loginInfo.InaccessibleUrlList) {
    return !loginInfo.InaccessibleUrlList.includes(pathname);
  }
  return (path == '/Home' || path == '/Home/Procurement' || path == '/Home/Workshop' || accessible);
}

// const AuthenRoute = ({ component: Component, openTour, setTourCurrentStep, ...rest }) =>
const AuthenRoute = ({ component: Component, ...rest }) =>
  <Route
    {...rest}
    render={props => {
      // return ((loginInfo.UserID && loginInfo.UserID.coun )
      //   ? <Component {...props} />
      //   : <Redirect
      //     to='/login'
      //   />)

      // //console.log(paths);(loginInfo);
      // //console.log(props);

      if (loginInfo.UserID) {
        if (Component
          && CheckAccessibility(props.location.pathname)
        )
          return (<Component {...props} name={rest.name} />);
        else
          return (<Redirect to='/Home' />);
      }

      else {
        // console.log("props.location.search",props.location.search);
        // console.log("props.location.pathname",props.location.pathname);
        window.TargetURL = props.location.pathname;
        window.TargetSearch = props.location.search;
        if (window.TargetURL && window.TargetSearch)
          return (<Redirect to='/EmailDirect' />);
        else
          return (<Redirect to='/login' />);
      }


    }}

  />;

export default AuthenRoute;


// WEBPACK FOOTER //
// ./src/components/AuthenRoute.js